import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["action", "name", "id", "attributes"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var createExperienceTrackerAnalyticsEventPayload = function createExperienceTrackerAnalyticsEventPayload(event) {
  return {
    // Events should match the schema defined here:
    // https://hello.atlassian.net/wiki/spaces/BIZOPS/pages/387788554/Analytics+Event+Schema+for+SLA
    source: 'ui',
    actionSubject: 'ui',
    action: event.action,
    eventType: 'operational',
    attributes: createExperienceTrackerAnalyticsAttributes(event)
  };
};
function createExperienceTrackerAnalyticsAttributes(event) {
  var action = event.action,
    name = event.name,
    id = event.id,
    experienceAttributes = event.attributes,
    rest = _objectWithoutProperties(event, _excluded);
  var attributes = _objectSpread(_objectSpread(_objectSpread({}, experienceAttributes), rest), {}, {
    task: name,
    taskId: id
  });
  if (attributes.error) {
    var error;
    if (typeof attributes.error === 'string') {
      error = new Error(attributes.error);
    } else {
      error = attributes.error;
    }
    delete attributes.error;
    attributes.errorName = error.name;
    if (!attributes.traceId && error.traceId) {
      attributes.traceId = error.traceId;
    }
    attributes.errorMessage = error.message;
  }
  attributes.browserInfo = window.navigator.userAgent;

  // Matches the analytics-web-client's apdex event
  attributes.isActiveTab = document.visibilityState === 'visible';
  return attributes;
}